import { Box, Flex } from '@chakra-ui/react';
import { About } from './view/about';
import { Reputation } from './view/reputation';
import { Activity } from './view/activity';
import { Notifications } from './view/notifications';
import { OrderHistory } from './view/order_history';
import { _js } from '@ifixit/localize';
import { SidebarDataType } from './Sidebar/sidebar';

function CurrentViewPanel({
   userid,
   tab,
   setUnreadNotifCount,
   sidebarData,
}: {
   userid: number;
   tab: any;
   setUnreadNotifCount: (count: number) => void;
   sidebarData: SidebarDataType;
}) {
   switch (tab.name) {
      case 'About': {
         return <About userid={userid} data={tab.data} sidebarData={sidebarData} />;
      }
      case 'Reputation': {
         return <Reputation data={tab.data} />;
      }
      case 'Activity': {
         return <Activity userid={userid} data={tab.data} />;
      }
      case 'Notifications': {
         return <Notifications data={tab.data} setUnreadNotifCount={setUnreadNotifCount} />;
      }
      case 'Orders': {
         return <OrderHistory data={tab.data} />;
      }
      default: {
         return <Box>{_js('An error occurred.')}</Box>;
      }
   }
}

export function UserView({
   userid,
   currentTab,
   setUnreadNotifCount,
   sidebarData,
}: {
   userid: number;
   currentTab: any;
   setUnreadNotifCount: (count: number) => void;
   sidebarData: SidebarDataType;
}) {
   return (
      <Flex
         justify="space-between"
         w="full"
         gap="36px"
         maxW="100%"
         direction={{ base: 'column-reverse', lg: 'row' }}
      >
         <CurrentViewPanel
            userid={userid}
            tab={currentTab}
            sidebarData={sidebarData}
            setUnreadNotifCount={setUnreadNotifCount}
         />
      </Flex>
   );
}
